<script>
  import { _, json } from 'svelte-i18n'
  import { slide } from 'svelte/transition'
  import { hobby_font_limit } from '../stores'
  
  let activeIndices = [];
  export let faqContent =  $_('faq');
  export let compact = false;
  
  function toggleItem(index) {
    if (activeIndices.includes(index)) {
      activeIndices = activeIndices.filter(i => i !== index);
    } else {
      if (compact) {
        // In compact mode, only one question can be open at a time
        activeIndices = [index];
      } else {
        // Normal behavior - multiple questions can be open
        activeIndices = [...activeIndices, index];
      }
    }
  }

  // Create a derived store or computed value for the FAQ entries
  $: faqEntries = Object.entries(faqContent).map(([key, value]) => ({
    key,
    q: value.q,
    a: value.a.replaceAll('{hobby_font_limit}', $hobby_font_limit)
  }));
</script>

<div class="section faq" class:compact>
  <ul>
    {#each faqEntries as faq, index}
      <li on:click={() => toggleItem(index)} class:active={activeIndices.includes(index)}>
        <span class="plus-minus">{activeIndices.includes(index) ? '▾' : '▸'}</span>{@html faq.q}
        {#if activeIndices.includes(index)}
          <p transition:slide={{ duration: 300 }}>
            {@html faq.a}
          </p>
        {/if}
      </li>
    {/each}
  </ul>
  <b>Have more questions?</b>
  <br/>Write us at <a href="mailto:contact@wordmark.it">contact@wordmark.it</a>
</div>

<style>
  ul {
    margin-top: 2rem;
  }
  li {
    margin-bottom: 2rem;
    font-size: 2.1rem;
    line-height: 3rem;
    letter-spacing: -0.4px;
    color: var(--c-text);
    cursor: pointer;
  }
  li:hover,
  li:hover .plus-minus {
    color: var(--c-accent);
  }
  li.active {
    color: var(--c-accent);
    margin-bottom: 3rem;
  }
  li p {
    color: var(--c-text-faded);
  }
  li p :global(a) {
    color: var(--c-text-faded) !important;
  }
  li p :global(a):hover {
    color: var(--c-accent) !important;
  }
  li .plus-minus {
    color: var(--c-text-faded);
    font-size: 2.1rem;
    font-weight: 500;
    font-family: var(--Helvetica);
    line-height: 3rem;
    margin-right: 1rem;
    margin-left: -2rem;
  }
  li.active .plus-minus {
    margin-right: 0.8rem;
  }

  .compact {
    font-size: 1.5rem;
  }
  .compact ul {
    margin-bottom: 2rem;
  }
  .compact li {
    font-size: 1.5rem;
    line-height: 2rem;
    margin-bottom: 1rem;
  }
  .compact li .plus-minus {
    line-height: 2rem;
    font-size: 1.6rem;
  }
  .compact li p {
    color: var(--c-text);
  }
  .compact li.active {
    font-family: var(--PensumSans-Bold);
  }
  .compact li.active p {
    font-family: var(--PensumSans);
  }
</style>